import {TDocumentDefinitions} from "pdfmake/interfaces";
import pdfMake from "pdfmake/build/pdfmake";
import {vfs_fonts} from "./fonts/vfs_fonts";
pdfMake.vfs = vfs_fonts;

export const generatePDF = (pages: TDocumentDefinitions) => {
    pdfMake.vfs = vfs_fonts;

    getPDF(pages).open();
};

export const getPDF = (pages: TDocumentDefinitions) => {
    pdfMake.vfs = vfs_fonts;

    return pdfMake.createPdf(
        pages,
        {},
        {
            MyriadPro: {
                normal: "MyriadPro-Regular.ttf",
                bold: "MyriadPro-Bold.ttf",
                italics: "MyriadPro-It.ttf",
                bolditalics: "MyriadPro-BoldIt.ttf",
            },
        }
    );
};
